import React from 'react';
import ReactDOM from 'react-dom/client';
import './main.css';
import App from './App';

// This is all you need in index.js
const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Fallback for missing root div
  document.body.innerHTML = '<h1 style="color:red;text-align:center">App failed to load: Missing root div</h1>';
}
